import React from 'react';
import Button from '@material-ui/core/Button';
import { useSelector } from 'react-redux';

import { useHistory } from 'react-router-dom';

import useStyles from './style';
import { findPermission } from '../../services/auth';

export default function Subheader({
  title,
  back,
  submit,
  submitText,
  loading,
  create,
  subanchor,
  isDisabled,
  onClickParam = null,
  style,
  isModal = false,
  extraBtnList = [],
  extraBtn = false,
  extraBtnText = '',
  extraBtnFunction = null,
}) {
  const classes = useStyles();
  const history = useHistory();

  const { lastAnchor } = useSelector((state) => state.anchors);

  return (
    <div className={isModal ? classes.rootModal : classes.root} style={style}>
      <span className={classes.title}>
        {title} {subanchor && lastAnchor}
      </span>
      <div className={classes.divButton}>
        {extraBtnList.map((btn) => (
          <Button
            variant="contained"
            onClick={btn.onclick}
            style={{ width: 400, textTransform: 'none' }}
            className={classes.buttonExtra}
            disabled={btn.disabled}
          >
            {btn.text}
          </Button>
        ))}
        {extraBtn && !loading && (
          <Button
            variant="contained"
            onClick={extraBtnFunction}
            className={classes.buttonExtra}
            disabled={isDisabled}
          >
            {extraBtnText}
          </Button>
        )}
        {submit && !loading && (
          <Button
            variant="contained"
            onClick={submit}
            className={classes.buttonSubmit}
            disabled={isDisabled}
          >
            {submitText}
          </Button>
        )}

        {!!findPermission(711, 'Cadastrar') && create && !loading && (
          <button variant="contained" onClick={create} className={classes.buttonSubmit}>
            Novo item
          </button>
        )}

        {onClickParam && (
          <Button variant="contained" className={classes.button} onClick={onClickParam}>
            Voltar
          </Button>
        )}

        {back && !onClickParam ? (
          <Button
            variant="contained"
            className={classes.button}
            onClick={(event) => history.push(back)}
          >
            Voltar
          </Button>
        ) : (
          back === false && (
            <Button
              variant="contained"
              className={classes.button}
              onClick={(event) => history.goBack()}
            >
              Voltar
            </Button>
          )
        )}
      </div>
    </div>
  );
}
